import React from 'react';
import { View, TouchableOpacity } from 'react-native';
import { Box, Inline } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import PortalOverlay, { PortalOverlayModal } from '../../../../ui/PortalOverlay';
import {
  BodyText,
  HeaderText,
  Stack,
  ModalBox,
} from '../../../../ui';
import { ChevronIcon } from '../../../../ui/Icons';
import { RatingTagInfo } from '../../../../../modules/provider/reviews';

const ReviewTagsModal = ({
  selectedTag,
  onRequestClose,
  renderReviewList,
}: {
  selectedTag: RatingTagInfo;
  onRequestClose: () => void;
  renderReviewList: () => React.ReactNode;
}) => (
  <PortalOverlay name="filtered-by-tag-review-list-modal" animationStyle="slideLeft">
    <PortalOverlayModal position="fullScreen" color={BrandColor.SuperLight}>
      <Stack padding={16} paddingBottom={4} color={BrandColor.WhiteWash}>
        <View>
          <Inline
            paddingTop={4}
            paddingBottom={12}
          >
            <TouchableOpacity
              testID="FilteredByTagReviewsPopupCloseBtn"
              onPress={() => { onRequestClose(); }}
            >
              <Box paddingTop={3} paddingRight={20}>
                <ChevronIcon
                  direction="left"
                  width={20}
                  height={20}
                />
              </Box>
            </TouchableOpacity>
            <HeaderText level={1}>Reviews</HeaderText>
          </Inline>
        </View>
      </Stack>
      <ModalBox
        scrollable
        padding={0}
      >
        <Inline
          justifyContent="flex-start"
          alignItems="center"
          padding={12}
        >
          <BodyText weight="bold">
            Reviews that mention:{' '}
          </BodyText>
          <BodyText weight="bold" color={BrandColor.FloraDark}>
            {selectedTag.value}{' '}
          </BodyText>
          <BodyText color={BrandColor.Silver} weight="bold">
            {selectedTag.count}
          </BodyText>
        </Inline>
        <Box paddingX={12}>
          {renderReviewList()}
        </Box>
      </ModalBox>
    </PortalOverlayModal>
  </PortalOverlay>
);

export default ReviewTagsModal;
